//import { Link, useHistory } from 'react-router-dom';

const RealSplitTokenomics = () => {
//export default const RealSplitTokenomics = () => {
//export default RealSplitTokenomics = () => {
//export const RealSplitTokenomics = () => {
    return (
        <>

        <h1
            style = {{
                //color: 'var(--color-gray-700)'
                color: 'white'
                , textAlign: 'center'
                , fontFamily: 'Baskervville'
            }}>
            RealSplit Tokenomics
        </h1>

        <div
            className="about-section"
            style = {{ marginTop: '100px' }}
            >

            <div
                className = 'about-section-circle-wrapper'
                //style = {{
                //    textAlign: 'center'
                //    , margin: 'auto'
                //    , marginTop: '-65px'
                //}}
                >
                <div
                    className = 'about-section-circle'
                    >
                    <img
                        //src = '/images/icons/pool-8-ball.svg'
                        src = '/images/logos/RealSplit-Token_700x703.png'
                        //style = {{ maxHeight: '100px', maxWidth: '100px' }}
                    />
                </div>
            </div>

            <h2>
                RealSplit (RS) Token
            </h2>

            <h3>
                Key to Profit Sharing
            </h3>
            
            <p>
                The RS token is the key to Profit Sharing. It enables investors to earn a percentage of all profits generated from transactions on the RealSplit platform. Profit share is determined by the number of RS Tokens owned.
            </p>
            {/* Dermot suggested
            <p>
                Dermot suggested: The RS token is the key to Profit Sharing. It enables investors to earn a percentage of all profits generated from transactions on the RealSplit platform. Profit share is determined by the number of RS Tokens owned.
            </p>
            <p>
                Previous content: The RS token enables investors to earn a percentage of all profits generated on the RealSplit platform, which is determined by the number of Tokens they own.
            </p>
            */}

            <div style = {{ margin: 'auto', textAlign: 'center' }}>
                <img
                    style = {{
                        margin: 'auto'
                        , textAlign: 'center'
                        , width: '100%'
                        , maxWidth: '500px'
                    }}
                    src = '/images/diagrams/RealSplit-Tokenomics-Platform-Fees-Pie-Chart.png'
                    />
            </div>

            {/* Dermot suggest we move this below
            <h3>
                Flexible Staking
            </h3>
            <p>
                Unlike many Tokens that require long staking periods, RS holders can stake their tokens for as little as 30 days, offering greater flexibility.
            </p>
            */}

            <p>
                RealSplit collaborates with our banking partner, Circle, to convert all fiat funds received by RealSplit into USDC/USDT stablecoin (learn more at Investopedia).
            </p>

            <p>
                RealSplit also uses USDC for all of its expenses, allowing us to provide token holders with a monthly report detailing income and expenses. This report will calculate the amount of distributable cash available. Since this report is stored on the blockchain, it can be easily audited.
            </p>
            
            <p>
                Unlike most tokens that pay in their native currency, RS pays exclusively in USDC, also known as "digital cash."
            </p>

            <h3>
                Airdrop for RS Token Holders
            </h3>
            <p>
                RealSplit is excited to unveil our airdrop campaign, rewarding early RS token holders. 
                This initiative is dedicated to distributing bonus tokens to members who have helped promote RealSplit and bring in members that have purchased Tokens. 
                The RealSplit Platform has a sophisticated affiliate system built into the Platform and each member receives a unique link that tracks the signups off all new members that use it.
            </p>

            <h3>
                Investment Clubs Airdrops
            </h3>
            <p>
                The top 5% of Investment Club’s that have the most “new member” signups for the month will earn a chance to enter a raffle to determine the number of tokens they get.
            </p>
            <p>
                Raffles winners get to play a mini game that determines the number of Tokens the Club will receive, with the Investment Club Leader receiving 10% of the Total Tokens and the remaining split evenly amongst all the Club members.
            </p>

            <h3>
                Airdrop Execution and Schedule
            </h3>
            <p>
                The winning Investment Club will immediately be airdropped their Tokens.
            </p>

            <h3>
                Community Engagement and Education
            </h3>
            <p>
                <strong>CRE Education Programs</strong>
                <br/>To encourage informed participation, we offer educational resources and workshops on CRE asset Tokenization.  Members from Investment Clubs can volunteer to teach these workshops.  This is a great opportunity for Investment Clubs to recruit new members.
            </p>
            <p>
                <strong>Feedback and Improvement Channels</strong>
                <br/>Continuous feedback from the community is sought and encouraged. This includes regular surveys, open forums, and suggestion boxes.
            </p>

        </div>

        <div className="about-section">

            <div
                className = 'about-section-circle-wrapper'
                //style = {{
                //    textAlign: 'center'
                //    , margin: 'auto'
                //    , marginTop: '-65px'
                //}}
                >
                <div className = 'about-section-circle'>
                    <img
                        className = 'svg'
                        src = '/images/icons/RealSplit-Engagement-Incentives-Icon.png'
                        //style = {{ maxHeight: '100px', maxWidth: '100px' }}
                    />
                </div>
            </div>

            <h2>
                Engagement and Incentive Mechanisms
            </h2>

            <p>
                RealSplit’s goal is to foster active participation and reward community engagement.  
                These  are essential to maintaining a vibrant and dynamic community. We have designed a variety of engagement and incentive mechanisms to encourage token holders to take an active role in recruiting new members, promoting RealSplit Properties.
            </p>

            <h3>
                Rewarding Participation
            </h3>
            <p>
                Token holders who are active in the community social channels and help promote RealSplit in a positive manner. This incentive is designed to encourage a high level of participation in the RealSplit public Telegram and our private members only Discord.
            </p>
            <p>
                <strong>Contribution Recognition</strong>
                <br/>Contributions to discussions, forums, and committees are recognized and rewarded. Active community members who provide valuable insights and constructive feedback receive incentives as a token of appreciation.
            </p>

            <h3>
                Gamification of Participation
            </h3>
            <p>
                <strong>Achievement Badges and Tiers</strong>
                <br/>To make participation more engaging, we’ve introduced a gamification system. Members can earn badges and earn points that are needed to earn a military style rank system. Each rank offers different perks and rewards.
            </p>
            <p>
                <strong>Special Access and Privileges</strong>
                <br/>High Rank members have the opportunity to receive special access to exclusive private pre-sale deals, private events, private Discord channels, beta testing opportunities, and direct channels to the RealSplit development team.
            </p>

            <h3>
                Gamification and Raffles
            </h3>
            <p>
                Realsplit’s platform is designed with engaging opportunities for our community. Here are some examples of how we plan to gamify and engage with our members:
                <ul>
                    <li>Community Badges, Flair, and tiered User Reward Milestones across all levels of investor classes.</li>
                    <li>We will host events at the RealSplit properties launched on the platform. Our digital raffle technology will allow RealSplit members to win tickets to these events, as well as other prizes sponsored by both RealSplit and our clients.</li>
                    <li>RealSplit and our CRE clients will also give away fractional ownership ("Splits") in the projects they launch.</li>
                    <li>All members will have the chance to claim a free ticket for each raffle and can earn additional tickets based on community involvement.</li>
                </ul>
            </p>

            <h3>
                Encouraging Long-Term Engagement
            </h3>
            <p>
                <strong>Longevity Bonuses</strong>
                <br/>Members who consistently participate over longer periods are eligible for longevity bonuses, recognizing and rewarding their sustained commitment to the platform.
            </p>

            <h3>
                Educational Incentives
            </h3>            
            <p>
                <strong>Learning and Earning</strong>
                <br/>We offer educational programs about blockchain, CRE, and the RealSplit platform. Participants in these programs can lead to new members signing up, which will earn tokens and increase the number of points for a new Rank.
            </p>
            <p>
                <strong>Feedback Loop Rewards</strong>
                <br/>Members providing constructive feedback on how to improve governance processes are acknowledged with rewards. This ensures that the DAO continually evolves and improves based on community input.
            </p>

            <h3>
                Transparency in Incentives
            </h3>
            <p>
                <strong>Clear Incentive Structure</strong>
                <br/>All rewards and incentives are clearly outlined, with transparent criteria for how they are earned. This clarity ensures fairness and maintains trust within the community.
            </p>
            <p>
                <strong>Regular Review and Adjustment</strong>
                <br/>The incentive mechanisms are reviewed regularly to ensure they remain effective and aligned with the platform’s goals and community needs.
            </p>

        </div>

        <div className="about-section">

            <div
                className = 'about-section-circle-wrapper'
                //style = {{
                //    textAlign: 'center'
                //    , margin: 'auto'
                //    , marginTop: '-65px'
                //}}
                >
                <div className = 'about-section-circle'>
                    <img
                        className = 'svg'
                        //src = '/images/icons/donut-chart.svg'
                        src = '/images/icons/Pie-Chart-Icon_914x896.png'
                        //style = {{ maxHeight: '100px', maxWidth: '100px' }}
                    />
                </div>
            </div>

            <h2>
                Tokenomics of RealSplit
            </h2>

            <p>
                The tokenomics of RealSplit have been crafted to foster a sustainable and vibrant ecosystem, balancing the aspects of utility and rewards. Our approach integrates innovation and gamification to encourage active participation and drive the platform’s growth and success.
                Our tokenomics model is straightforward: it's based on pure utility. RS Token powers all transactions on the RealSplit platform.
                <ul>
                    <li>To access private pre-sales or early investment opportunities, you must use the RS Token.</li>
                    <li>Investors who use RS Tokens to make investments will receive bonus raffle tickets and gain entry to exclusive “Investor-Only” raffles.</li>
                    <li>All tokens in your wallet are available for investment on the platform, or they can be staked for a minimum of 30 days to earn a pro-rata share of profits during that time.</li>
                    <li>Staking your RS Tokens for longer periods will earn additional profit-sharing bonuses based on the length of the lock-up.</li>
                    <li>Non-staked tokens can be transferred to an exchange for liquidation at any time. However, all RS tokens purchased from an exchange must be moved to the RealSplit platform for use.</li>
                </ul>
            </p>

            <h3>
                Priority Access for Token Holders
            </h3>
            <p>
                <strong>First Access to New Projects</strong>
                <br/>Holders of RealSplit tokens are granted first access to participate in projects launching on our platform. Stake RS tokens and earn points toward a higher Rank (to be whitelisted for upcoming projects — more you spend, higher the allocation.
            </p>

            <h3>
                Token Distribution and Allocation
            </h3>
            {/*
            <p>
                <ul>
                    <li><strong>Total Supply:</strong><br/>The total supply of RealSplit tokens are strategically capped at a certain number to ensure scarcity and intrinsic value. </li>
                    <li><strong>Max Token Supply:</strong><br/>USD $80M</li>
                </ul>
            </p>
            */}
            <p>
                <strong>Total Supply</strong><br/>The total supply of RealSplit tokens are strategically capped at a certain number to ensure scarcity and intrinsic value.
            </p>
            <p>
                <strong>Max Token Supply</strong>
                <br/>
                {/*
                USD $80M
                */}
                To be confirmed
            </p>

            <p>
                <strong>Public</strong>
                <br/>
                {/*
                58% of the supply has been sold to the public via our initial launch.
                */}
                To be confirmed
            </p>

            <p>
                <strong>Community Allocation</strong>
                <br/>
                {/*
                12.5% of the total supply is allocated to rewards for staking, airdrops, participation incentives, liquidity and community-driven initiatives.
                */}
                To be confirmed
            </p>

            <p>
                <strong>Liquidity</strong>
                <br/>
                {/*
                5% of the supply has been allocated to liquidity.
                */}
                To be confirmed
            </p>

            <p>
                <strong>RealSplit</strong>
                <br/>
                {/*
                20% of the total token supply is earmarked for RealSplit Technology Group, the parent company. This consolidated fund supports ongoing platform development, enhancements, and the founding team (18-month vesting and 25% 6-month cliff).
                */}
                To be confirmed
            </p>

            <h3>
                Flexible Staking
            </h3>
            <p>
                Unlike many Tokens that require long staking periods, RS holders can stake their tokens for as little as 30 days, offering greater flexibility.
            </p>

            <h3>
                Unstaking and Re-staking Process
            </h3>

            <p>
                <strong>Unstaking Post-Lock</strong>
                <br/>Unstake tokens after the 90-day lock period.
                <br/>Contract applies final yield calculations before processing.
            </p>

            <p>
                <strong>Re-staking</strong>
                <br/>Re-staking resets the yield increase multiplier.
                <br/>New staking starts a fresh 90-day lock period.
            </p>

            <p>
                <strong>Impact on Multiplier</strong>
                <br/>Upon any unstaking, the multiplier resets to base level (1x).
            </p>

            <p>
                <strong>Adding Additional RS Tokens</strong>
                <br/>Add more tokens to the staked balance anytime.
                <br/>Action resets the lock period.
            </p>

            <h3>
                Gamified Incentive Structure
            </h3>
            <p>
                RealSplit’s tokenomics incorporates a unique gamified incentive structure, designed to significantly enhance user engagement and experience on the platform. This approach transforms routine interactions into an exciting and rewarding journey, encouraging users to actively participate in various platform activities.
            </p>

            <p>
                <strong>Ranking System</strong>
                <br/>Users can earn a higher rank by engaging with the platform. Starting from a basic level, each subsequent tier offers increasing rewards and privileges.
                <br/><strong>Achievement Milestones</strong>
                <br/>Specific actions and contributions on the platform unlock achievement milestones, rewarding users with bonus tokens or exclusive perks.
            </p>

            <h3>
                Quests and Challenges
            </h3>

            <p>
                <strong>Daily and Weekly Quests</strong>
                <br/>Regular quests are set for users, ranging from simple tasks like participating in a forum discussion to more complex activities like contributing to a project’s development. Completing these quests yields token rewards.
                <br/><strong>Special Event Challenges</strong> 
                <br/>Periodic challenges aligned with significant events or platform milestones offer larger reward pools. These could range from content creation contests to referral sprints.
            </p>

            <h3>
                Token Staking Adventures
            </h3>
            <p>
                <strong>Staking for Rewards</strong>
                <br/>Users can stake their tokens to embark on “staking adventures”, which are thematic staking pools with varying risk-reward profiles and durations.
                <br/><strong>Interactive Staking</strong>
                <br/>These staking adventures are more than passive income streams; they involve active participation, which enhances the staking experience.
            </p>

            <h3>
                Social and Community Competitions
            </h3>
            <p>
                <strong>Leaderboards</strong>
                <br/>Activity leaderboards foster a competitive spirit among users, with top performers in various categories (e.g., affiliate signups, project support) receiving token bonuses. 
                <br/><strong>Community Battles</strong>
                <br/>Investment Clubs will participate in community battles — contests that require collective effort to win rewards. These battles strengthen community bonds and collaborative efforts.
            </p>

            <h3>
                Educational Rewards
            </h3>
            <p>
                <strong>Learn and Earn</strong>
                <br/>Engaging educational modules offer users opportunities to earn tokens while enhancing their understanding of tokenization of CRE assets.
                <br/><strong>Creative Contributions</strong>
                <br/>Users contributing educational content or tutorials for the community are rewarded, incentivizing knowledge sharing.
            </p>

            <h3>
                Personalized Achievement Tracks
            </h3>
            <p>
                <strong>Customizable Goals</strong>
                <br/>Users can set personal achievement tracks based on their interests and engagement levels, with corresponding rewards upon completion.
                <br/><strong>Feedback-Based Evolution</strong>
                <br/>The gamified system evolves based on user feedback and participation patterns, ensuring a continually fresh and engaging experience.
            </p>

            <h3>
                Dynamic Reward Mechanism
            </h3>
            <p>
                A performance-based rewards system is implemented, dynamically adjusting the rewards based on engagement levels and contributions to the platform, fostering a proactive community. 
                <br/>This token distribution strategy is tailored to ensure that all parties involved, from advisors to community members, are equally incentivized to contribute to and benefit from the growth and success of RealSplit.
            </p>

        </div>

        </>
    );
};
  
export default RealSplitTokenomics;